import React from 'react'

function Copyright() {
  return (
    <div className='copyright'>
        <div className="container d-flex justify-content-between align-items-center">
            <h6>Copyright © 2024 Nexelis By Nexelis Technologies. All Rights Reserved.</h6>
            <h6>Powered By Nexelis Technologies</h6>
        </div>
    </div>
  )
}

export default Copyright
